import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

export const TrimaThanksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${prem(40)} ${prem(20)};
  max-width: ${prem(400)};
  margin: 0 auto;
  min-height: 100%;
  gap: ${prem(18)};

  .trima-check {
    width: ${prem(80)};
    height: ${prem(80)};
    color: var(--ion-color-success, #2dd36f);

    svg {
      width: 100%;
      height: 100%;
    }
  }

  h1 {
    font-size: ${prem(24)};
    font-weight: 700;
    margin: 0;
  }

  .trima-thanks-body {
    font-size: ${prem(15)};
    color: var(--ion-text-color-secondary);
    line-height: 1.5;
    margin: 0;
  }

  .trima-thanks-spam {
    font-size: ${prem(13)};
    color: var(--ion-text-color-secondary);
    font-style: italic;
    margin: 0;
  }

  .trima-thanks-cta {
    margin-top: ${prem(20)};
    min-width: ${prem(200)};
  }
`;
